import leaveRequests from "../../services/leaveRequest";

const employee = {
  state: {
    expenseTypes: [],
    expenseSelected: null,
    leaveRequestsTypes: [],
    leaveRequesSelected: null,
    statuses: []
  },
  actions: {
    async fetchLeaveRequestType(store) {
      return new Promise(async (resolve, reject) => {
        await leaveRequests.getListLeaveRequestType().then(res => {
          if (res.success) {
            let options = res.data.map((type) => ({ value: type.pkIxLeaveType, text: type.leaveType }))
            store.commit('SET_LEAVE_REQUESTS_TYPE', options)
            resolve(res)
          } else {
            reject()
          }
        }).catch(err => {
          reject(err)
        })
      })
    },
    getLeaveRequestStatuses(store) {
      return new Promise((resolve, reject) => {
        leaveRequests.getListLeaveRequestStatus().then(res => {
          if (res.success) {
            store.commit('SET_LEAVE_REQUEST_STATUSES', res.data);
            resolve(res);
          } else {
            reject();
          }
        }).catch(err => {
          reject(err);
        })
      });
    }
  },
  mutations: {
    SET_EXPENSE_TYPES: (state, types) => {
      state.expenseTypes = types;
    },
    EXPENSE_SELECTED: (state, data) => {
      state.expenseSelected = data
    },
    SET_LEAVE_REQUESTS_TYPE: (state, types) => {
      state.leaveRequestsTypes = types
    },
    SET_LEAVE_REQUEST_STATUSES: (state, statuses) => {
      state.statuses = statuses
    },
    LEAVE_REQUEST_SELECTED: (state, data) => {
      state.leaveRequesSelected = data
    }
  },
  getters: {
    expenseTypes: (state) => state.expenseTypes,
    getExpenseSelected: (state) => state.expenseSelected,
    leaveRequestsTypes: (state) => state.leaveRequestsTypes,
    leaveRequestStatuses: (state) => state.statuses,
    leaveRequestsStatus: (state) => (statusId) => {
      if (!statusId) return null
      const selectStatus = state.statuses.find((item) => item.pkIxLeaveStatut === statusId);
      return selectStatus? selectStatus.statutLeave : null
    }, 
    getLeaveRequestSelected: (state) => state.leaveRequesSelected
  }
};

export default employee;
